import styled from 'styled-components';
import CommonTable from 'components/table/CommonTable';
import { PromoCode } from 'models/PromoCode';
import mediaQuery from 'styles/mediaQuery';

export const PromoCodesTableStyled = styled(CommonTable<PromoCode>)`
  .column-actions {
    width: 80px;
  }

  .column-value {
    width: 150px;
  }

  .column-status {
    width: 90px;
  }

  .column-expirationUTCDateTime {
    width: 110px;
  }

  .column-validFromUTCDateTime {
    width: 155px;
  }

  .column-propertyUid {
    width: 120px;
  }

  .column-singleUsage {
    width: 100px;
  }

  ${mediaQuery.md} {
    .column-value {
      width: 100px;
    }

    .column-status {
      width: 60px;
    }

    .column-expirationUTCDateTime {
      width: 90px;
    }

    .column-validFromUTCDateTime {
      width: 155px;
    }

    .column-propertyUid {
      width: 100px;
    }

    .column-singleUsage {
      width: 50px;
    }
  }
`;
